module.exports = __webpack_public_path__ + "static/media/reload-icon.52ac1bbb.svg";